export default __webpack_public_path__ + "static/media/opa-card-faq.b2fb70ed.png";